// ProjectBoardServices/BoardModalAPI/LeftModalAPI/RelatedDesignsTabAPI.js

import { axiosInstance } from "../../../../Services";

// Table data
export const fetchInventoryVersions = async (cardId) => {
  try {
    const res = await axiosInstance.get(
      `/mmhboard/cards/inventory/${cardId}?parent=1`
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// Modal versions API
export const fetchInventoryVersionsById = async (parentId) => {
  try {
    const res = await axiosInstance.get(
      `/rsform/inventories/versions/${parentId}`,
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// ✅ FIXED: Mark as Deliverable API (browser-compatible)
export const markAsDeliverable = async (cardId, deliverableId, outputId = "") => {
  try {
    // Browser ka native FormData use karo
    const formData = new FormData();
    formData.append("deliverable_id", deliverableId);
    formData.append("output_id", outputId);

    const res = await axiosInstance.post(
      `/mmhboard/cards/deliverable/${cardId}`,
      formData,
    );
    return res;
  } catch (error) {
    throw error;
  }
};
